module.exports = __webpack_public_path__ + "static/logo-dc3685826723c32ef0dddaeaba01c679.png";